
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';
import 'leaflet/dist/leaflet.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);

// Global Error Handler for Extension Noise
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('message channel closed')) {
    event.preventDefault();
    console.warn('Suppressing known extension error: Message channel closed');
  }
});

root.render(
  <React.StrictMode>
    <ErrorBoundary onReset={() => { localStorage.clear(); sessionStorage.clear(); window.location.reload(); }}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
